import * as actions from './actions';

export default function (
  state = {
    activationFee: {},
    paymentLoader: false,
    appealCategories: [],
    vettingSettings: [],
    countries: [],
    brandIdentityStatus: [],
    loaStatus: [],
    patentOffices: [],
    stockExchanges: [],
    trademarkVerificationStatus: [],
    verticalTypes: [],
    dcas: [],
  },
  action
) {
  switch (action.type) {
    case actions.ACTIVATION_FEE:
      return {
        ...state,
        activationFee: action.payload,
      };
    case actions.PAYMENT_LOADER:
      return {
        ...state,
        paymentLoader: action.payload,
      };
    case actions.SET_APPEAL_CATEGORIES:
      return {
        ...state,
        appealCategories: action.payload.map((item) => ({
          ...item,
          appealCategoryId: item.id,
        })),
      };
    case actions.SET_VETTING_SETTINGS:
      return {
        ...state,
        vettingSettings: action.payload,
      };
    case actions.SET_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
      };
    case actions.SET_BRAND_IDENTITY_STATUS:
      return {
        ...state,
        brandIdentityStatus: action.payload,
      };
    case actions.SET_LOA_STATUS:
      return {
        ...state,
        loaStatus: action.payload,
      };
    case actions.SET_STOCK_EXCHANGES:
      return {
        ...state,
        stockExchanges: action.payload,
      };
    case actions.SET_TRADEMARK_VERIFICATION_STATUS:
      return {
        ...state,
        trademarkVerificationStatus: action.payload,
      };
    case actions.SET_VERTICAL_TYPES:
      return {
        ...state,
        verticalTypes: action.payload,
      };
    case actions.SET_DCAS:
      return {
        ...state,
        dcas: action.payload,
      };
    case actions.SET_PATENT_OFFICES:
      return {
        ...state,
        patentOffices: action.payload,
      };
    default:
      return state;
  }
}
